// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__ES7y4","footer":"ChangeClinic_footer__3B4dw"};